import { call, put, select } from 'redux-saga/effects';
import { api, showSuccessNotification, showErrorNotification } from '@med-fe/util';
import {
  fetchImportDetailsSuccess,
  fetchImportDetailsFailed,
  validateFileSuccess,
  validateFileFailed,
  processImportSuccess,
  processImportFailed,
  updateProcessImportResponse,
  downloadFileSuccess,
  downloadFileFailed,
  downloadSnapshotFileSuccess,
  downloadSnapshotFileFailed,
  deleteFileSuccess,
  deleteFileFailed,
  fetchImportDetails,
  setSearchImport,
} from './import-actions';

const searchPayload = {
  page: 0,
  size: 15,
};

export function* getImportsStartWorker({ payload }): Generator {
  try {
    const url = `/import/search`;
    const data = yield call(api.post, url, payload);
    yield put(fetchImportDetailsSuccess(data));
  } catch (e) {
    yield put(fetchImportDetailsFailed(e));
    showErrorNotification();
  }
}

export function* validateFileStartWorker({ payload }: any): Generator {
  try {
    const url = '/import/validate';
    const formData = new FormData();
    formData.append('officeImportId', payload);
    const data = yield call(api.post, url, formData);
    showSuccessNotification('File Data Validation completed successfully');
    yield put(validateFileSuccess(data.dataValidated));
  } catch (e) {
    yield put(validateFileFailed());
    showErrorNotification('File Data validation failed');
  }
}

export function* processImportStartWorker({ payload }): Generator {
  try {
    const url = `/import/process/${payload}`;
    const data = yield call(api.post, url, payload);
    yield put(processImportSuccess(data.dataProcessed));
  } catch (e) {
    yield put(processImportFailed());
    showErrorNotification('Processing Import File Failed. Please try again.');
  }
}

export function* downloadFileStartWorker({ payload }: any): Generator {
  try {
    yield call(api.downloadResourceFile, '/import/download', payload, 'POST');
    yield put(downloadFileSuccess());
  } catch (e) {
    yield put(downloadFileFailed());
    showErrorNotification();
  }
}

export function* downloadValidatedFileStartWorker({ payload }: any): Generator {
  try {
    yield call(api.downloadResourceFile, '/import/download/validate', payload, 'POST');
    yield put(downloadFileSuccess());
  } catch (e) {
    yield put(downloadFileFailed());
    showErrorNotification();
  }
}

export function* downloadSnapshotFileStartWorker({ payload }: any): Generator {
  try {
    yield call(api.downloadResourceFile, '/import/download/snapshot', payload, 'POST');
    yield put(downloadFileSuccess());
  } catch (e) {
    yield put(downloadFileFailed());
    showErrorNotification();
  }
}

export function* deleteResourceStartWorker({ payload }): Generator {
  try {
    const url = `/import/delete/${payload}`;
    const data = yield call(api.delete, url);
    yield put(deleteFileSuccess());
    showSuccessNotification('File deleted successfully');
    yield put(fetchImportDetails(searchPayload));
  } catch (e) {
    yield put(deleteFileFailed());
    showErrorNotification();
  }
}
